var n = "_spinner_1jekj_1",
  s = "_spin_1jekj_1",
  e = {
    spinner: n,
    spin: s
  };
export { e as default, s as spin, n as spinner };